import axios from 'axios';

import { KanzhongBackend } from 'constant/KanzhongBackend';

/**
 * トレース登録API (API1101)
 * 画面遷移時にアクセス履歴を記録する。
 * @param accessUrl - アクセスURL（必須, 最大512文字, パスパラメータ・クエリパラメータ除去済み）
 */
export const createTrace = async (accessUrl: string): Promise<void> => {
  const sessionId = localStorage.getItem('session-id');
  if (!sessionId) {
    return;
  }

  try {
    await axios.post(
      KanzhongBackend.CREATE_TRACE,
      { accessUrl },
      {
        headers: {
          'X-Session-Id': sessionId,
        },
      },
    );
  } catch (error) {
    // トレースはバックグラウンド処理のため、エラーを握りつぶす
    // ユーザー操作を妨げないことを優先する
    if (axios.isAxiosError(error) && error.response) {
      console.warn('[Trace] Failed to create trace:', error.response.status);
    } else {
      console.warn(
        '[Trace] Failed to create trace:',
        error instanceof Error ? error.message : error,
      );
    }
  }
};
